import React from 'react';
import {
  DataGrid as MuiDataGrid,
  GridColDef,
  DataGridProps,
} from '@mui/x-data-grid';
import MuiCircularProgress from '@mui/material/CircularProgress';
import { Typography } from '../typography';
import { styledComponent } from '../../hoc';

export const DataGrid = ({
  columns,
  emptyMessageTitle,
  emptyMessageDescription,
  ...props
}: DataGridComponentProps) => {
  const CustomNoRowsOverlay = () => {
    return (
      <CustomNoRowsOverlayContainer>
        <Typography variant="labelLG">{emptyMessageTitle}</Typography>
        <Typography variant="bodySM">{emptyMessageDescription}</Typography>
      </CustomNoRowsOverlayContainer>
    );
  };

  const columnHeader: GridColDef[] = columns.map(column => ({
    ...column,
    renderHeader: () => (
      <Typography variant="labelLG">{column.headerName}</Typography>
    ),
  }));

  const CustomLoadingOverlay = () => {
    return (
      <LoadingOverlayContainer>
        <MuiCircularProgress />
      </LoadingOverlayContainer>
    );
  };

  return (
    <DataGridContainer>
      <MuiDataGrid
        columns={columnHeader}
        style={{ border: 'none' }}
        components={{
          NoRowsOverlay: CustomNoRowsOverlay,
          LoadingOverlay: CustomLoadingOverlay,
        }}
        {...props}
      />
    </DataGridContainer>
  );
};

type DataGridComponentProps = {
  columns: GridColDef[];
  emptyMessageTitle?: string;
  emptyMessageDescription?: string;
} & DataGridProps;

const DataGridContainer = styledComponent('div')(() => ({
  height: 400,
  width: '100%',
  padding: '16px 16px 5px 16px',
}));

const LoadingOverlayContainer = styledComponent('div')(() => ({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  height: '100%',
}));

const CustomNoRowsOverlayContainer = styledComponent('div')(() => ({
  textAlign: 'center',
  padding: '16px',
  marginTop: '120px',
  fontSize: '16px',
  display: 'flex',
  flexDirection: 'column',
}));
